import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { StyledUtils } from '@ocean/utils'

export const AnimatedBanner = styled.div`
  transition: max-height 1s ease-out;
  position: relative;

  &.banner-enter {
    max-height: 0;
  }
  &.banner-enter-active {
    max-height: 200px;
  }
  &.banner-exit {
    transition: max-height 0.2s ease-out;
    max-height: 200px;
  }
  &.banner-exit-active {
    max-height: 0;
  }
`

export const Wrapper = styled.div`
  min-height: 50px;

  ${({ theme }) => `
    background-color: ${theme.color.gold};
    padding: ${theme.space.mobile.tiny} ${theme.space.mobile.base};
    padding-right: ${theme.space.desktop.large};
  `}

  ${({ theme }) => media.sm`
    padding: ${theme.space.desktop.tiny} ${theme.space.desktop.small};
    padding-right: ${theme.space.desktop.large};
  `}
`

export const CloseButton = styled.button`
  ${StyledUtils.clearButton}
  position: absolute;
  display: flex;
  justify-content: flex-end;

  ${({ theme }) => `
    width:  ${theme.space.mobile.large}; 
    height: ${theme.space.mobile.large}; 
    top: calc(${theme.space.mobile.tiny} + 2px);
    right: ${theme.space.mobile.base}; 

    svg {
      width: ${theme.space.mobile.small}; 
      height: ${theme.space.mobile.small}; 
      
      g {
        stroke: ${theme.color.black};
      }
    }
  `}

  ${({ theme }) => media.sm`
    top: calc(${theme.space.desktop.tiny} + 2px);
  `}
`
